export class TipoContaModel {

    public codTipoConta: number;
    public nomTipoConta: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/tipo-conta.model.ts